import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { StatusLabel } from '@shared/components';
import { useDocumentTitle } from '@shared/hooks';
import { TERMINOLOGY } from '@shared/i18n';
import { SignInContext } from '@modules/users';
import { isTFolder, useFolder } from '@modules/items';
import { isRegistrationsEnabled } from '../helpers/registrationAccess';
import RegistrationsContent from '../components/RegistrationsContent';

// Flat route: `/registrations`. The drawer and breadcrumbs belong to the country registrations root folder.
// The route guard runs before anything registration-specific mounts, so a disabled organization makes no request.
const Registrations = () => {
  const { organization } = useContext(SignInContext);
  const countriesFolderId = organization.folders.countries;
  const isEnabled = isRegistrationsEnabled(organization) && Boolean(countriesFolderId);

  useDocumentTitle(`${TERMINOLOGY.registrationFull.upper} dashboard`);

  const { error, data } = useFolder(countriesFolderId, { enabled: isEnabled });

  if (!isEnabled) return <Navigate to="/" replace />;

  return (
    <StatusLabel
      data={data}
      error={error}
      loadingMessage={`Loading ${TERMINOLOGY.registrationFull.lower}...`}
      errorMessage={`Loading ${TERMINOLOGY.registrationFull.lower} failed!`}
      render={(folder) => isTFolder(folder) && <RegistrationsContent countriesFolder={folder} />}
    />
  );
};

export default Registrations;
